const QuestionLeadingText = ({ questionType, ...otherProps }) => {
  const renderContent = () => {
    switch (questionType) {
      case "matrix": {
        const { orientation } = otherProps;
        return `Marca una opción por cada ${orientation === "column" ? "columna" : "fila"} en la
            cuadrícula.`;
      }
      case "options": {
        const { selection = "single", maximumCheckedOptions } = otherProps;
        let text = "";
        if (selection === "multiple") {
          text += `Marca todas las opciones que correspondan. ${
            maximumCheckedOptions
              ? "Puedes seleccionar hasta " + maximumCheckedOptions + " alternativas."
              : ""
          }`;
        } else {
          text += "Marca solamente una opción.";
        }
        return text;
      }
      case "dropdown": {
        const { selection = "single" } = otherProps;
        let text = "De la lista desplegable, selecciona ";
        if (selection === "multiple") {
          text += " todas las opciones que correspondan.";
        } else {
          text += " solamente una opción.";
        }
        return text;
      }
      default: {
        return "";
      }
    }
  };

  const renderOptionalMessage = () => {
    const { optional, show_optional_message } = otherProps;

    if (optional && show_optional_message) {
      return "Pregunta opcional.";
    }

    return "";
  };

  return (
    <div className="d-flex flex-column mb-2">
      <span className="font-italic">{renderContent()}</span>
      <span className="font-italic">{renderOptionalMessage()}</span>
    </div>
  );
};

export default QuestionLeadingText;
